"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { useState } from "react";

import LoginModal from "~/components/v3/themed/LoginModal";
import { CommunityCreateModal } from "~/components/v3/community-components/CommunityCreateModal";
import { Button, ButtonLink } from "~/components/v3/themed/Button";
import { useLaunchCommunity } from "~/hooks/useLaunchCommunity";

export const HeroButtons = () => {
    const [isEventsModalOpen, setIsEventsModalOpen] = useState(false);

    const { isCommunityCreateVisible, setCreateCommunityVisible } =
        useLaunchCommunity();

    return (
        <div className="flex flex-col gap-4 md:flex-row">
            <Button
                className="h-[50px] min-w-max"
                variant="secondary"
                onClick={() => setIsEventsModalOpen(true)}
            >
                Host your first event
            </Button>
            {/* <button
                className="h-[50px] min-w-max text-white underline underline-offset-4 hover:text-v3-primary"
                onClick={() => setCreateCommunityVisible(true)}
            >
                Launch your community
            </button> */}

            <CommunityCreateModal
                isVisible={isCommunityCreateVisible}
                setVisible={(visible, routing) => {
                    setCreateCommunityVisible(visible, routing);
                }}
            />
            <LoginModal
                isOpen={isEventsModalOpen}
                setIsOpen={setIsEventsModalOpen}
                title="Sign in to create an event"
                description="Create your event page and start hosting events."
                callbackUrl="/beta/events/create"
            />
        </div>
    );
};

export const FooterButtons = () => {
    const searchParams = useSearchParams();
    const router = useRouter();
    const [isCommunityCreateVisible, setIsCommunityCreateVisible] = useState(
        () => {
            return searchParams?.get("createCommunity") === "true";
        },
    );
    const setCreateCommunityVisible = (
        visible: boolean,
        routing: boolean = false,
    ) => {
        setIsCommunityCreateVisible(visible);

        const newUrl = new URL(window.location.href);
        if (visible) {
            newUrl.searchParams.set("createCommunity", "true");
        } else {
            newUrl.searchParams.delete("createCommunity");
        }

        // if creating a community, we don't want to hijack the routing since a new community is being created
        if (!routing) {
            router.replace(newUrl.pathname + newUrl.search, {
                scroll: false,
            });
        }
    };

    return (
        <>
            <div className="mt-0 flex gap-4 md:mt-4">
                <ButtonLink
                    href="http://getriver.io/"
                    target="_blank"
                    variant="secondary"
                >
                    Learn more
                </ButtonLink>
                {/* <Button onClick={() => setCreateCommunityVisible(true)}>
                    Launch your community
                </Button> */}
            </div>
            <CommunityCreateModal
                isVisible={isCommunityCreateVisible}
                setVisible={(visible, routing) => {
                    setCreateCommunityVisible(visible, routing);
                }}
            />
        </>
    );
};
